module.exports = __webpack_public_path__ + "static/media/compare_60.613dbbf7.svg";